<template>
	<div class="mainContentBackground villageBackground unselectable">
		<div class="sea viewBackground" :style="{top: '0px', left: villageBackgroundLeft, right: 'auto', height: '1440px', transform: 'perspective(1000px) scale3d(1, 1, 1)', transformOrigin: '50% 50%', filter: 'blur(0px)', perspective: '1000px'}">
			<div class="modalWrapper profile" style="opacity: 1; top: 400px; align-items: flex-start; justify-content: center; display: flex; width: 100%; height: 100%;">
				<div class="modal profile">
					<div class="modalContent">
						<div class="modalDecoration"></div>
						<div class="functionPanel unselectable">
							<a class="closeWindow clickable" @click="$router.push('/township')">
								<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
									<i class="action_cancel_tiny_flat_black"></i>
								</div>
							</a>
						</div>
						<div>
							<div class="contentHeader unselectable">
								<h2 class="msAntiScroll drag" draggable="true">
									<span class="building"><span>{{player.username}}</span></span>
								</h2>
							</div>
						</div>
						<div class="heightTransitionContent" :style="{maxHeight: maxHeightContent}">
							<div class="contentTabulation">
								<nav class="tabulation maintab unselectable" v-if="!$route.params.id || $route.params.id == gameModel.player.id">
									<a class="tab clickable" :class="{active: tab == 'player-profile', inactive: tab != 'player-profile'}" @click="onToggleTab('player-profile')">
										<div class="content">
											<span>Профиль игрока</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'prestige', inactive: tab != 'prestige'}" @click="onToggleTab('prestige')">
										<div class="content">
											<span>Престиж</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'settings', inactive: tab != 'settings'}" @click="onToggleTab('settings')">
										<div class="content">
											<span>Настройки</span>
										</div>
									</a>
								</nav>
								<div class="tabulationContent scrollable">
									<div class="scrollContentOuterWrapper">
										<div class="scrollContent" style="overflow-y: auto;" :style="{maxHeight: maxHeightInnerContent}">
											<div class="scrollContentInnerWrapper" style="width: auto;">
												<div class="loadedTab currentTab" v-if="tab == 'player-profile'">
													<player-profile :player="player"></player-profile>
												</div>
												<div class="loadedTab currentTab" v-if="tab == 'prestige' && (!$route.params.id || $route.params.id == gameModel.player.id)">
													<prestige></prestige>
												</div>
												<div class="loadedTab currentTab" v-if="tab == 'settings' && (!$route.params.id || $route.params.id == gameModel.player.id)">
													<settings></settings>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="window-overlay">
							
							<!-- редактирование описания профиля -->
							<player-profile-edit-description v-if="gameModel.profile.playerProfileEditDescriptionShow" />
							
							<!-- заместители и дуалы -->
							<manage-sitter-and-duals v-if="gameModel.profile.manageSitterAndDualsShow" />
							
							<!-- создать доступ для внешних инструментов -->
							<get-external-login v-if="gameModel.profile.getExternalLoginShow" />
							
							<!-- удалить героя -->
							<start-deletion v-if="gameModel.profile.startDeletionShow" />
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import PlayerProfile from '@/components/pages/profile/PlayerProfile';
import Prestige from '@/components/pages/profile/Prestige';
import Settings from '@/components/pages/profile/Settings';

import PlayerProfileEditDescription from '@/components/pages/profile/windowOverlay/PlayerProfileEditDescription';
import ManageSitterAndDuals from '@/components/pages/profile/windowOverlay/ManageSitterAndDuals';
import GetExternalLogin from '@/components/pages/profile/windowOverlay/GetExternalLogin';
import StartDeletion from '@/components/pages/profile/windowOverlay/StartDeletion';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Персонаж | IW'});
	},
	data: () => ({
		maxHeightContent: '550px',
		maxHeightInnerContent: '530px',
		cancelHover: false,
		
		player: {},
		tab: 'player-profile',
		showSearch: false,
		windowOverlayOpen: false,
		
		villageBackgroundLeft: '0px',
	}),
	computed: {},
	methods: {
		async loadPlayerData(){
			if(this.$route.params.id == this.gameModel.player.id){
				this.player = this.gameModel.player;
			} else {
				await setTimeout(() => {
					this.player = this.gameModel.player;
				}, 100);
			}
		},
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_20.ogg');
				audio.play();
			}
		},
		onModalClose(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_7.ogg');
				audio.play();
			}
		},
		onToggleTab(tab, push = true){
			this.tab = tab;
			if(push) this.$router.push({query: {tab}});
			
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_8.ogg');
				audio.play();
			}
		},
		
		onResize(){
			//let leftpos = (window.innerWidth / 2) - (1920 / 2) - 70;
			let leftpos = (window.innerWidth / 2) - (1920 / 2);
			//console.log(window.innerWidth, leftpos);
			this.villageBackgroundLeft = leftpos+'px';
			
			let maxHeightContent = window.innerHeight - 325;
			maxHeightContent = (maxHeightContent < 550 ? 550 : maxHeightContent);
			this.maxHeightContent = maxHeightContent + 'px';
			this.maxHeightInnerContent = (maxHeightContent - 57 > 0 ? maxHeightContent - 57 : 0) + 'px';
		},
	},
	async mounted(){
		this.onModalOpen();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
		
		await this.loadPlayerData();
		
		if(this.$route.query.tab) this.tab = this.$route.query.tab;
		else this.$router.push({query: {tab: this.tab}});
	},
	unmounted(){
		this.onModalClose();
		
		window.removeEventListener('resize', this.onResize); 
	},
	beforeRouteUpdate(to, from, next){
		if(!to.query.tab) this.$router.push({query: {tab: 'player-profile'}});
		else if(to.query.tab != this.tab) this.onToggleTab(to.query.tab, false);
		next();
	},
	created(){
		this.gameModel.buildingQueueShow = true;
	},
	components: {
		PlayerProfile,
		Prestige,
		Settings,
		
		PlayerProfileEditDescription,
		ManageSitterAndDuals,
		GetExternalLogin,
		StartDeletion,
	},
}
</script>